export type MailboxMessageAttachmentAssignment = {
  id: number;
  candidateId: number;
  attachment: Attachment;
};

enum VisibilityLevel {
  Public = 'public',
  Protected = 'protected',
  Private = 'private',
}

export type Attachment = {
  id: number;
  admin: any;
  adminId: number;
  candidate?: any | null;
  candidateId: number | null;
  createdAt: string;
  extension: string;
  fileUrl: string;
  filename: string;
  guest?: any;
  guestId?: number;
  imageThumbnailUrl?: string;
  pdfThumbnailUrl?: string;
  imageUrl?: string;
  pdfUrl?: string;
  offerId: number | null;
  status: string;
  uploader: string;
  private: boolean;
  visibility?: {
    adminIds: number[];
    level: VisibilityLevel;
    roleIds: number[];
  };
  fileSize: number;
};
